angular.module("ticketco/ticketbuyer/time_slots", [
  "ticketco/common/time_slots",
  "ticketco/ticketbuyer/common",
]);
